import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import Link from '../Link/Link';

type Type = 'info' | 'success' | 'warning' | 'error';

const theme = {
  error: {
    background: 'var(--red1c)',
    font: 'var(--red3c)',
  },

  success: {
    background: 'var(--green1c)',
    font: 'var(--green7)',
  },
  warning: {
    background: 'var(--yellow-dark)',
    font: 'var(--yellow0)',
  },
  info: {
    background: 'var(--mainDark)',
    font: 'var(--mainLight)',
  },
};

const labelStyle = css<{
  $margin?: string;
  onClick?: (event?: unknown) => void;
  href?: string;
  $type?: Type;
}>`
  display: inline-block;
  color: ${props => (props.$type ? theme[props.$type].font : theme.info.font)};
  background: ${props =>
    props.$type ? theme[props.$type].background : theme.info.background};
  font-size: var(--small);
  text-align: center;
  padding: 4px 8px;
  margin: ${({ $margin }) => $margin ?? '0 5px'};
  border-radius: 5px;
  ${({ onClick, href }) =>
    (onClick || href) &&
    css`
      &:hover {
        filter: brightness(1.2);
      }
    `}
`;

const Label = styled.div<{
  $margin?: string;
  onClick?: (event?: unknown) => void;
  $type?: Type;
}>`
  cursor: ${props => (props.onClick ? 'pointer' : 'initial')};
  ${labelStyle}
`;

const LabelLink = styled(Link)<{
  $margin?: string;
  href?: string;
  onClick?: undefined;
  $type?: Type;
}>`
  ${labelStyle}
`;

type IProps = {
  children?: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  type?: Type;
  margin?: string;
};

// TODO: vaults color of text broken in Vault detail header - enforce color
export default function LabelClickable({
  onClick,
  disabled = false,
  type,
  margin,
  children,
}: IProps) {
  return (
    <Label
      onClick={disabled ? undefined : onClick}
      $type={type}
      $margin={margin}
    >
      {children}
    </Label>
  );
}

type ILinkProps = {
  children?: ReactNode;
  href: string;
  disabled?: boolean;
  type?: Type;
  margin?: string;
};

export function _LabelExternalLink({
  href,
  disabled = false,
  type,
  margin,
  children,
}: ILinkProps) {
  return (
    <LabelLink href={disabled ? undefined : href} $type={type} $margin={margin}>
      {children}
    </LabelLink>
  );
}
